import {Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {Logger} from '@services/logger.service';
import {ContractService} from "@services/contract.service";
import { AuthService } from 'src/app/core/auth/auth.service';
import { ValidateTokenDto } from 'src/app/core/auth/dtos/validate-token.dto';
import {LocalstorageService} from "@services/localstorage.service";
import { ValidateCodeVerifierDto } from 'src/app/core/auth/dtos/validate-codeverifier.dto';

const log = new Logger('LoginComponent');

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  isLoading = false;
  action: any;
  error: string;
  message: string;
  validateToken: ValidateTokenDto;
  validateCodeVerifier: ValidateCodeVerifierDto;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private oauthService: OAuthService,
    private contractService: ContractService,
    private authService: AuthService,
    private localstorageService: LocalstorageService
  ) {
  }

  ngOnInit() {
    this.removeConfigurationInStorage();

    this.route.queryParams.subscribe(params => {
      const token = params['externalToken'];
      const scope = params['scope'];
      
      if (token) {
        this.externalToken(token);
      } 
      else if (scope && scope.split(' ').includes('tm_authbridge_rejected_api')) {
        const state = params['state'];  
        this.loginBridge(state);       
      }
      else {
        this.loginOrFirstAccess();
      }
    });

  }

  private removeConfigurationInStorage(): void {
    try {
      this.localstorageService.removeAllProfiles();
      this.contractService.removeContract();
    } catch (error) {
      log.error("Erro ao remover configuração de autenticação", error);
    }
  }

  loginOrFirstAccess() {
    this.route.queryParams.subscribe(parametros => {
      if (parametros.redirect == "/?action=firstAccess") {
        this.router.navigate(['/primeiro-acesso']);
      } else {
        this.login()
      }
    });
  }

  async loginBridge(state: string): Promise<void> {
    
    this.validateCodeVerifier = await this.authService.validateCodeVerifier(state);

    localStorage.setItem('state', state);
    localStorage.setItem('nonce', state);
    localStorage.setItem('PKCE_verifier', this.validateCodeVerifier.codeVerifier);
      
    await this.authService.callbackLoginBridge(); 

    if (this.oauthService.hasValidAccessToken()) {
      
      this.router.navigate(['/login/auth-bridge-success'], {
            queryParams: {},
            replaceUrl: true
      });

    }
    else {
      this.redirectToWelcomePage();
    }
  }

  async login(): Promise<void> {
    this.isLoading = true;
    this.message = "Verificando sessão.";
    try {
      await this.authService.callbackLogin();

      if (this.oauthService.hasValidAccessToken()) {
        this.router.navigate(['/selecionar-perfil'], {
          queryParams: {},
          replaceUrl: true
        });
      } else {
        this.redirectToWelcomePage();
      }
    } catch (error) {
      this.error = "Não foi possível inicializar sua sessão.";
      log.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  async externalToken(token: string) {
    this.isLoading = true;
    this.message = "Validando token externo.";

    try {
      this.validateToken = await this.authService.validateExternalToken(token);

      if (!this.validateToken.success) {
        this.message = "Não foi possível inicializar sua sessão com o token externo.";
        throw new Error("Token inválido ou expirado.");
      }

      this.oauthService.setStorage(localStorage);
      localStorage.setItem('access_token', this.validateToken.code);

      await this.oauthService.tryLogin();

      if (this.oauthService.hasValidAccessToken()) {
        this.router.navigate(['/selecionar-perfil'], {
          queryParams: {},
          replaceUrl: true
        });
      } else {
        throw new Error("Token inválido ou expirado.");
      }

    } catch (error) {
      this.error = "Não foi possível inicializar sua sessão com o token externo.";
    } finally {
      this.isLoading = false;
    }
  }

  redirectToWelcomePage() {
    this.removeConfigurationInStorage();
    this.message = "Redirecionando para tela de login.";
    this.router.navigate(['/login/bem-vindo']);
  }

  tryAgain() {
    this.oauthService.logOut();
    localStorage.clear()
    document.location.reload();
  }

}
